import React from 'react';
import { capitalize } from 'lodash';
import { FaPencilAlt } from 'react-icons/fa';
import { useParams, useHistory } from 'react-router-dom';

import Button from 'partial/components/Button';
import GenericDetails from 'partial/components/GenericDetails';

import { useSelectedCashback } from '../hooks';

function ViewCashback() {
  const history = useHistory();
  const { biller_id, cashback_id } = useParams();
  const [isLoading, data] = useSelectedCashback(biller_id, cashback_id);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-medium">Cashback Details</h1>
        <button
          type="button"
          onClick={() =>
            history.push(`/billers/profile/cashback/edit/${cashback_id}`)
          }
          className="p-2 border border-gray-400 text-gray-400 rounded"
        >
          <FaPencilAlt />
        </button>
      </div>
      <GenericDetails
        data={data}
        format={[
          {
            label: 'Cashback Name',
            key: 'title',
          },
          {
            label: 'Status',
            key: (row) => (
              <span
                className={`${
                  row?.status === 'active' ? 'text-secondary-800' : ''
                }`}
              >
                {capitalize(row?.status)}
              </span>
            ),
          },
          {
            label: 'Cashback',
            key: 'amount_human',
          },
        ]}
        numberOfCols={2}
        isLoading={isLoading}
      />
      <h1 className="text-xl font-medium">Price Amount Range</h1>
      <GenericDetails
        data={data}
        format={[
          {
            label: 'Minimum Amount',
            key: 'minimum_range_amount_human',
          },
          {
            label: 'Maximum Amount',
            key: 'maximum_range_amount_human',
          },
        ]}
        numberOfCols={2}
        isLoading={isLoading}
      />
      <h1 className="text-xl font-medium">Validity (Optional)</h1>
      <GenericDetails
        data={data}
        format={[
          {
            label: 'Start Date',
            key: 'validity_start_date_human',
          },
          {
            label: 'End Date',
            key: 'validity_end_date_human',
          },
        ]}
        numberOfCols={2}
        isLoading={isLoading}
      />
      <Button
        type="button"
        outlinePrimary
        onClick={() => history.push('/billers/profile/cashback')}
      >
        Back
      </Button>
    </div>
  );
}

export default ViewCashback;
